var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.50854C7 1.2324 6.77614 1.00854 6.5 1.00854C6.22386 1.00854 6 1.2324 6 1.50854V7.30144L3.85355 5.15499C3.65829 4.95973 3.34171 4.95973 3.14645 5.15499C2.95118 5.35025 2.95118 5.66684 3.14645 5.8621L6.14645 8.8621C6.34171 9.05736 6.65829 9.05736 6.85355 8.8621L9.85355 5.8621C10.0488 5.66684 10.0488 5.35025 9.85355 5.15499C9.65829 4.95973 9.34171 4.95973 9.14645 5.15499L7 7.30144V1.50854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5085C1.5 10.2324 1.72386 10.0085 2 10.0085H11C11.2761 10.0085 11.5 10.2324 11.5 10.5085C11.5 10.7847 11.2761 11.0085 11 11.0085H2C1.72386 11.0085 1.5 10.7847 1.5 10.5085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.7328173ba5fd7b83dac7171789bfeba6.svg";
export { ForwardRef as ReactComponent };